import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { t2medBridge } from '../api/bridge';

/**
 * Mirrors "the user is inside a session" into the plugin so the
 * writeback poller runs at its fast cadence during an active consult
 * and drops to the slow background cadence otherwise.
 *
 * Aligned with `useChronicleSyncRouteSession`: waits for `router.isReady`
 * and requires a session id in the route — `/scribe/sessions/[[...id]]`
 * is an optional catch-all that also serves the session *list* view,
 * where fast polling would be wasted.
 */
export function useT2medRouteSessionActivity(): void {
  const router = useRouter();

  const isSessionPage = router.pathname.startsWith('/scribe/session');
  const routeId = router.query.id;
  const sessionId = Array.isArray(routeId) ? routeId.at(0) : routeId;
  const onSession = router.isReady && isSessionPage && Boolean(sessionId);

  useEffect(() => {
    if (onSession) {
      void t2medBridge.activateSession();
      return () => {
        void t2medBridge.deactivateSession();
      };
    }
    return undefined;
  }, [onSession]);
}
